import React from "react";
import TicketLanding from "../../components/ticket-system/ticketLanding";
import HelmetWrapper from "../../HelmetWrapper";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import "../../styles/ticket-system/ticket-system.css";

const TicketSystem = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Ticket Management">
      <Container className="bg-cloud-k ticket-system-container" fluid>
        <TicketLanding userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default TicketSystem;
